<template>
  <form role="form" @submit.prevent="onSubmitForm()">
    <h6 class="mb-0">{{ titlePage }}</h6>
    <p class="mb-0 text-sm">{{ subtitlePage }}</p>
    <hr class="my-3 horizontal dark" />
    <div class="form-group" v-if="record.id != null">
    <label class="form-label">User ID</label>
    <input type="text" class="form-control" v-model="record.id" disabled />
    </div>
    <div class="form-group">
    <label for="fullName" class="form-label">Full Name</label>
    <input id="fullName" type="text" class="form-control" v-model="record.fullname" />
    </div>
    <div class="form-group">
    <label for="email" class="form-label">Email</label>
    <input id="email" type="email" class="form-control" v-model="record.username" />
    </div>
    <div class="form-group" v-if="record.id == null">
    <label for="password" class="form-label">Password</label>
    <input id="password" type="password" class="form-control" v-model="record.password" />
    </div>
    <div class="form-group">
    <label for="phone" class="form-label">Phone</label>
    <input id="phone" type="text" class="form-control" v-model="record.phone" />
    </div>
    
    <div class="form-group" v-if="false">
    <label for="role" class="form-label">Role</label>
    <select class="dataTable-selector form-select form-select-sm" v-model="record.role_id" >
      <option v-for="item in roles" :value="item.id" :key="item.role" >{{ item.role }}</option>                        
    </select>
  </div>

    <div class="mt-4 d-flex justify-content-end">
    <a class="m-0 btn btn-light" @click.prevent="$emit('cancel')">
        Cancel
    </a>
    <a
        class="m-0 btn bg-gradient-danger ms-2"
        v-if="record.id != null && record.is_active"
        @click="userActiveAction(false)"
        
    >
        Deactivate
    </a>

    <a
        class="m-0 btn bg-gradient-info ms-2"
        v-if="record.id != null && !record.is_active"
        @click="userActiveAction(true)"
        
    >
        Activate
    </a>

    <button
        type="submit"
        name="button"
        class="m-0 btn bg-gradient-success ms-2"
        
    >
        {{ submitButtonName }}
    </button>
    </div>
  </form>
  </template>
  <script>
    import RoleService from "@/services/roles.service.js";


  export default {
    data() {
      return {
        record: {},
        roles: []
      };
    },
    props: {
        titlePage: String,
        subtitlePage: String,
        submitButtonName: String,
        onSubmit: { type: Function },
        onUpdateActivation: { type: Function },
        toggleModal: { type: Function },
        recordProps: { type: Object }
    },
    watch: {
        recordProps: function (newVal, oldVal) { // watch it
        console.log('Prop changed: ', newVal, ' | was: ', oldVal)
        this.record = newVal
        }
    },
    mounted() {
      this.getAllRoles()
    },
    methods: {
      userActiveAction(value) {
        console.log(value)
        this.onUpdateActivation(value)
      },
      onSubmitForm() {
        console.log('onSubmitForm')
        const payload = {
          username: this.record.username,
          fullname: this.record.fullname,
          phone: this.record.phone,
        }
        this.onSubmit(payload)
      },
      getAllRoles(){
      const params = {
          limit: 50,
          page: 1
        }
        RoleService.getAll(params).then(e => {
          const data = e.data
          this.roles = data.roles.filter(e => e.role == 'external-user')
          this.record.role_id = this.roles[0].id
        })
    }
    }
  }
  </script>
  